import { forwardRef } from 'react';

const VARIANTS = {
  primary:
    'bg-primary text-white shadow-soft hover:brightness-105 active:brightness-95',
  secondary:
    'bg-surfaceAlt text-text hover:bg-border',
  ghost:
    'bg-transparent text-text hover:bg-surfaceAlt',
  danger:
    'bg-danger text-white hover:brightness-105',
  outline:
    'border border-border bg-transparent text-text hover:bg-surfaceAlt',
};

const SIZES = {
  sm: 'px-3 py-1 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-base',
  icon: 'p-2 text-sm',
};

const Button = forwardRef(function Button(
  {
    children,
    variant = 'primary',
    size = 'md',
    className = '',
    iconLeft,
    iconRight,
    loading = false,
    disabled = false,
    type = 'button',
    ...rest
  },
  ref,
) {
  const classes = [
    'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
    'focus-visible:ring-offset-surface',
    'disabled:opacity-60 disabled:cursor-not-allowed',
    VARIANTS[variant] ?? VARIANTS.primary,
    SIZES[size] ?? SIZES.md,
    className,
  ].join(' ');

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={classes}
      {...rest}
    >
      {loading ? (
        <svg
          className="h-4 w-4 animate-spin"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3" opacity="0.25" />
          <path
            d="M21 12a9 9 0 0 0-9-9"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      ) : null}
      {!loading && iconLeft ? <span className="shrink-0">{iconLeft}</span> : null}
      <span>{children}</span>
      {!loading && iconRight ? <span className="shrink-0">{iconRight}</span> : null}
    </button>
  );
});

export default Button;
